export default {"src":"/_next/static/media/linkedin.d1f2f240.svg","height":24,"width":25,"blurWidth":0,"blurHeight":0};